import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { DataService } from '../_services/data.service';
import { Role } from '../_model/Role';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../_services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatOptionModule } from '@angular/material/core';

@Component({
  selector: 'app-roleselect',
  templateUrl: './roleselect.component.html',
  styleUrls: ['./roleselect.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule, 
    MatButtonModule,
    MatInputModule,
    MatOptionModule
  ]
})
export class RoleselectComponent implements OnInit {
  returnUrl: string;
  roles: Role[];
  selectedRole: Role = null;

  constructor(private dataService: DataService,
              private toastr: ToastrService,
              private authService: AuthenticationService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this.authService.currentUserValue) {
      this.router.navigateByUrl(this.returnUrl);
    }
    this.dataService.loginResponseObservable.subscribe(loginResponseResult => {
      this.roles = loginResponseResult.role;
      if(this.roles.length === 1){
        this.selectedRole = this.roles[0];
        this.loginWithRole();
      }
    });
  }

  loginWithRole() {
    if (this.selectedRole == null) {
      this.toastr.error('Rol Seçmelisiniz', 'Hata');
      return;
    }
    this.dataService.loginResponseObservable.subscribe(loginResponseData => {
      loginResponseData.selectedRole = this.selectedRole;
      localStorage.setItem('currentUser', JSON.stringify(loginResponseData));
      this.authService.assignCurrentUser(loginResponseData);
      this.router.navigateByUrl(this.returnUrl);
    });

  }
}
